module.exports = __webpack_public_path__ + "static/media/leftArrow.0c331a37.svg";